<script setup>
const route = useRoute();

useHead({
  title: "РУСДРАМ",
  meta: [
    {
      hid: "title",
      property: "title",
      content: "РУСДРАМ",
    },
    {
      hid: "og:title",
      property: "og:title",
      content: "РУСДРАМ",
    },
    {
      hid: "description",
      name: "description",
      content:
        "Контакты | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "og:description",
      property: "og:description",
      content:
        "Контакты | Государственный русский театр драмы им. Ф. А. Искандера",
    },
    {
      hid: "url",
      name: "url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "og:url",
      property: "og:url",
      content: `https://rusdram.org${route.fullPath}`,
    },
    {
      hid: "image",
      name: "image",
      content: "https://rusdram.org/rusdram.jpg",
    },
    {
      name: "og:image",
      property: "og:image",
      content: "https://rusdram.org/rusdram.jpg",
    },
  ],
});
</script>

<template>
  <nuxt-layout name="default">
    <r-section>
      <div
        class="container rounded-lg overflow-hidden bg-white grid grid-cols-1 lg:grid-cols-2 gap-7"
      >
        <div class="row-start-2 lg:row-start-1 h-80 lg:h-auto">
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3A0c64d2578cba66f562e5d4a0bbb321e74a563324c645580a39941d41a51e2f87&amp;source=constructor"
            frameborder="0"
            style="height: 100%; width: 100%"
          ></iframe>
        </div>
        <div class="py-4 flex flex-col space-y-8 px-4 lg:px-0">
          <h1 class="text-gray-dark text-4xl">Контакты</h1>

          <!-- Адрес -->
          <div class="flex flex-row space-x-4 px-2">
            <div>
              <r-icon icon="location" class="h-5 w-5"></r-icon>
            </div>
            <div class="flex flex-col space-y-4">
              <h6 class="text-primary text-lg">Адрес</h6>
              <div class="flex flex-col space-y-1">
                <h3 class="text-gray-dark text-lg-2">
                  Республика Абхазия, г. Сухум, проспект Леона, 8.
                </h3>
              </div>
            </div>
          </div>

          <!-- Email -->
          <div class="flex flex-row space-x-4 px-2">
            <div>
              <r-icon icon="email" class="h-5 w-5"></r-icon>
            </div>
            <div class="flex flex-col space-y-4">
              <h6 class="text-primary text-lg">E-mail</h6>
              <div class="flex flex-col space-y-1">
                <a
                  href="mailto:info@rusdram.org"
                  class="text-gray-dark text-lg-2"
                  >info@rusdram.org</a
                >
              </div>
            </div>
          </div>

          <!-- Телефоны -->
          <div class="flex flex-row space-x-4 px-2">
            <div>
              <r-icon icon="phone" class="h-5 w-5"></r-icon>
            </div>
            <div class="flex flex-col space-y-4">
              <h6 class="text-primary text-lg">Телефоны</h6>
              <div class="flex flex-col space-y-1">
                <a
                  href="tel:+7 (940) 7-204-204"
                  class="text-gray-dark text-lg-2"
                  >Касса: +7 (940) 7-204-204</a
                >
                <a
                  href="tel:+7 (940) 776-68-82"
                  class="text-gray-dark text-lg-2"
                  >Канцелярия: +7 (940) 776-68-82</a
                >
              </div>
            </div>
          </div>

          <!-- Время работы -->
          <div class="flex flex-row space-x-4 px-2">
            <div>
              <r-icon icon="duration-rounded" class="h-5 w-5"></r-icon>
            </div>
            <div class="flex flex-col space-y-4">
              <h6 class="text-primary text-lg">Время работы</h6>
              <div class="flex flex-col space-y-1">
                <h3 class="text-gray-dark text-lg-2">
                  с 10:00 до 20:00, без выходных
                </h3>
              </div>
            </div>
          </div>

          <!-- Реквизиты -->
          <div class="flex flex-row space-x-4 px-2">
            <div>
              <r-icon icon="ticket" class="h-5 w-5"></r-icon>
            </div>
            <div class="flex flex-col space-y-4">
              <h6 class="text-primary text-lg">Реквизиты</h6>
              <div class="flex flex-col space-y-1">
                <h3 class="text-gray-dark text-lg-2">
                  Государственное учреждение «Государственный русский театр драмы им. Ф.А. Искандера»
                </h3>
                <h3 class="text-gray-dark text-lg-2">ОГРН 107РА000700</h3>
                <h3 class="text-gray-dark text-lg-2">
                  Юр. адрес: 384900, Республика Абхазия, г. Сухум, Проспект Леона, 8.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </r-section>
  </nuxt-layout>
</template>
